export default __webpack_public_path__ + "static/media/line-left-bottom.d0e1958e.svg";